package com.example.mystybag.core.helpers

import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_COUNTRY_MODEL_KEY
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_FIRST_NAME
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_LAST_NAME
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_DIAL_CODE
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_PHONE_NUMBER
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_USER_IMG_URL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NUMBER_OF_RESERVATIONS
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NUMBER_OF_NOT_PICKED_RESERVATIONS
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_SAVED_AMOUNT
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_USER_ID
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.extensions.ifNotEmpty
import com.example.mystybag.core.model.DeepLinkModel
import com.example.mystybag.sharedmodels.common.responseModels.CountryModel
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import com.example.mystybag.core.expected.getDeviceUUID
import com.example.mystybag.sharedmodels.appConfig.ApplicationsConfigModel

@Suppress("VARIABLE_IN_SINGLETON_WITHOUT_THREAD_LOCAL")
object GlobalCommonData {
    private var firstName                       = ""
    private var lastName                        = ""
    private var email                           = ""
    private var cityId                          = 0L
    private var postCode                        = ""
    private var address                         = ""
    private var birthDate                       = ""
    private var phoneNumber                     = ""
    private var dialCode                        = ""
    private var longitude                       = -1f
    private var latitude                        = -1f
    private var isApplicationOnForeground       = false
    private var isLoginWithBiometrics           = false
    private var resourceId                      = ""
    private var userImgUrl                      = ""
    var userId                          = 0L
    private var numberOfReservations            = 0
    private var numberOfNotPickedReservations   = 0
    private var savedAmount                     = 0.0
    private var referralCode                    = ""

    private var deepLink                        : DeepLinkModel?     = null
    private var country                         : CountryModel?      = null

    private var applicationsConfig              = ApplicationsConfigModel()
    fun resetData(){
        email       = ""
        firstName   = ""
        lastName    = ""
        cityId      = 0L
        postCode    = ""
        address     = ""
        birthDate   = ""
        phoneNumber = ""
        dialCode    = ""
        latitude    = -1f
        longitude   = -1f
        userImgUrl  = ""
        numberOfReservations = 0
        numberOfNotPickedReservations = 0
        savedAmount = 0.0
        userId  = 0
    }

    fun setApplicationsConfig(appConfig: ApplicationsConfigModel) {
        applicationsConfig = appConfig
    }

    fun getApplicationsConfig(): ApplicationsConfigModel {
        return applicationsConfig
    }

    fun getUserIdValue(): Long{
        return when {
            userId > 0 -> userId
            else -> {
                userId = Preferences.getLong(PREFERENCES_USER_ID, 0L)
                userId
            }
        }
    }

    fun setUserIdValue(userIdValue: Long){
        userId = userIdValue
        Preferences.setLong(PREFERENCES_USER_ID, userIdValue)
    }


    fun getPhoneNumberValue(): String{
        return when {
            phoneNumber.isNotEmpty() -> phoneNumber
            else -> {
                phoneNumber = Preferences.getSecureString(PREFERENCES_PHONE_NUMBER, "")
                phoneNumber
            }
        }
    }

    fun setPhoneNumberValue(phoneNumberValue: String){
        phoneNumber = phoneNumberValue
        Preferences.setSecureString(PREFERENCES_PHONE_NUMBER, phoneNumberValue)
    }

    fun getDialCodeValue(): String {
        return when {
            dialCode.isNotEmpty() -> dialCode
            else -> {
                dialCode = Preferences.getSecureString(PREFERENCES_DIAL_CODE, "")
                dialCode
            }
        }
    }

    fun setDialCodeValue(dialCodeValue: String) {
        dialCode = dialCodeValue
        Preferences.setSecureString(PREFERENCES_DIAL_CODE, dialCodeValue)
    }

    fun getIsApplicationOnForeground(): Boolean = isApplicationOnForeground

    fun setApplicationOnForeground(isApplicationOnForeground: Boolean) {
        GlobalCommonData.isApplicationOnForeground = isApplicationOnForeground
    }

    fun setIsLoginWithBiometrics(isLoginWithBiometrics: Boolean) {
        GlobalCommonData.isLoginWithBiometrics = isLoginWithBiometrics
    }

    fun getIsLoginWithBiometrics(): Boolean {
        return isLoginWithBiometrics
    }

    fun getLongitude(): Float {
        return longitude
    }

    fun getLatitude(): Float{
        return latitude
    }

    fun setLongitudeAndLatitude(longitude: Float, latitude: Float) {
        this.longitude = longitude
        this.latitude = latitude
    }

    fun getFirstNameValue(): String{
        return when{
            firstName.isNotEmpty()    -> firstName
            else                            -> {
                firstName = Preferences.getSecureString(PREFERENCES_FIRST_NAME, "")
                firstName
            }
        }
    }

    fun setFirstNameValue(firstNameValue: String){
        firstName = firstNameValue
        Preferences.setSecureString(PREFERENCES_FIRST_NAME, firstNameValue)
    }

    fun getLastNameValue(): String{
        return when{
            lastName.isNotEmpty()    -> lastName
            else                            -> {
                lastName = Preferences.getSecureString(PREFERENCES_LAST_NAME, "")
                lastName
            }
        }
    }

    fun setLastNameValue(lastNameValue: String){
        lastName = lastNameValue
        Preferences.setSecureString(PREFERENCES_LAST_NAME, lastNameValue)
    }

    fun setClientCountryModelValue(countryModel: CountryModel){
        Preferences.setString(PREFERENCES_COUNTRY_MODEL_KEY, Json.encodeToString(country))
        country = countryModel
    }

    fun getClientCountryModelValue(): CountryModel {
        return country ?: run {
            Preferences.getString(PREFERENCES_COUNTRY_MODEL_KEY, "").ifNotEmpty {
                country = Json.decodeFromString(CountryModel.serializer(), it)
                country
            } ?: CountryModel()
        }
    }

    fun getLocationString(): String{
        val latitude    = getLatitude()
        val longitude   = getLongitude()
        return "$longitude;$latitude"
    }


    fun getEmailValue(): String{
        return email
    }

    fun setEmailValue(emailValue: String){
        email = emailValue
    }

    fun getCityId(): Long{
        return cityId
    }

    fun setCityId(cityIdent: Long){
        cityId = cityIdent
    }

    fun getPostCodeValue(): String{
        return postCode
    }

    fun setPostCodeValue(postCodeValue: String){
        postCode = postCodeValue
    }

    fun getAddressValue(): String{
        return address
    }

    fun setAddressValue(addressValue: String){
        address = addressValue
    }

    fun getDeepLinkValue(): DeepLinkModel? {
        return deepLink
    }

    fun setDeepLinkValue(deepLinkValue: DeepLinkModel?) {
        deepLink = deepLinkValue
    }

    fun getReferralCodeValue(): String {
        return referralCode
    }

    fun setReferralCodeValue(value: String) {
        referralCode = value
    }

    fun getResourceIDValue(): String{
        return when {
            resourceId.isNotEmpty() -> resourceId
            else -> getDeviceUUID().also {
                resourceId = it
            }
        }
    }

    fun getUserImgUrlValue(): String {
        return when {
            userImgUrl.isNotEmpty() -> userImgUrl
            else -> {
                userImgUrl = Preferences.getString(PREFERENCES_USER_IMG_URL, "")
                userImgUrl
            }
        }
    }

    fun setUserImgUrlValue(userImgUrlValue: String) {
        userImgUrl = userImgUrlValue
        Preferences.setString(PREFERENCES_USER_IMG_URL, userImgUrlValue)
    }

    fun getNumberOfReservationsValue(): Int {
        return when {
            numberOfReservations > 0 -> numberOfReservations
            else -> {
                numberOfReservations = Preferences.getInt(PREFERENCES_NUMBER_OF_RESERVATIONS, 0)
                numberOfReservations
            }
        }
    }

    fun setNumberOfReservationsValue(numberOfReservationsValue: Int) {
        numberOfReservations = numberOfReservationsValue
        Preferences.setInt(PREFERENCES_NUMBER_OF_RESERVATIONS, numberOfReservationsValue)
    }

    fun getNumberOfNotPickedReservationsValue(): Int {
        return when {
            numberOfNotPickedReservations > 0 -> numberOfNotPickedReservations
            else -> {
                numberOfNotPickedReservations = Preferences.getInt(PREFERENCES_NUMBER_OF_NOT_PICKED_RESERVATIONS, 0)
                numberOfNotPickedReservations
            }
        }
    }

    fun setNumberOfNotPickedReservationsValue(numberOfNotPickedReservationsValue: Int) {
        numberOfNotPickedReservations = numberOfNotPickedReservationsValue
        Preferences.setInt(PREFERENCES_NUMBER_OF_NOT_PICKED_RESERVATIONS, numberOfNotPickedReservationsValue)
    }

    fun getSavedAmountValue(): Double {
        return when {
            savedAmount > 0.0 -> savedAmount
            else -> {
                savedAmount = Preferences.getString(PREFERENCES_SAVED_AMOUNT, "0.0").replace(",", ".").toDoubleOrNull() ?: 0.0
                savedAmount
            }
        }
    }

    fun setSavedAmountValue(savedAmountValue: Double) {
        savedAmount = savedAmountValue
        Preferences.setString(PREFERENCES_SAVED_AMOUNT, savedAmountValue.toString())
    }
}